import * as React from "react";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { id, name, checked, onChecked, disabled, key } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div className="checkboxCustomSlider" key={key}>
      <input
        type="checkbox"
        style={{ display: "none" }}
        id={id}
        name={name}
        checked={checked}
        onChange={onChecked}
        disabled={disabled}
      />
      <label htmlFor={id} className="labelToggle">
        <span />
      </label>
    </div>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  name?: any;
  checked?: any;
  onChecked?: any;
  disabled?: any;
  id?: any;
  key?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/checkbox/component.tsx